export default __webpack_public_path__ + "static/media/acceso_perfiles_ilus4.f1c5cb41.svg";